import { Trans } from 'react-i18next';

import { Link, Typography } from '@mui/material';

type TCaptchaPolicyProps = {
  className?: string;
};

export const CaptchaPolicy = ({ className }: TCaptchaPolicyProps) => (
  <Typography variant="caption" color="text.secondary" className={className}>
    <Trans i18nKey="captcha.policy">
      <Link target="_blank" href="https://policies.google.com/privacy" rel="noreferrer noopener" />
      <Link target="_blank" href="https://policies.google.com/terms" rel="noreferrer noopener" />
    </Trans>
  </Typography>
);
